/**
 * Simple in-memory GET cache to reduce repeat calls (e.g. chapter list per language).
 * Keys are full URLs; entries expire after ttlMs.
 */
const store = new Map();

const DEFAULT_TTL_MS = 5 * 60 * 1000;

export function createCachedGet(axiosInstance, ttlMs = DEFAULT_TTL_MS) {
  return async function cachedGet(url, config = {}) {
    const now = Date.now();
    const entry = store.get(url);
    if (entry && now < entry.expiresAt) {
      return { data: entry.data, cached: true };
    }
    const response = await axiosInstance.get(url, config);
    store.set(url, { data: response.data, expiresAt: now + ttlMs });
    return { data: response.data, cached: false };
  };
}

export function invalidateCachedUrl(url) {
  store.delete(url);
}

/** Clear all cached entries (e.g. after a manual retry across the app). */
export function clearApiCache() {
  store.clear();
}
